"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useForm;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _any = _interopRequireDefault(require("lodash/fp/any"));
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _last = _interopRequireDefault(require("lodash/fp/last"));
var _identity = _interopRequireDefault(require("lodash/fp/identity"));
var _map = _interopRequireDefault(require("lodash/fp/map"));
var _prop = _interopRequireDefault(require("lodash/fp/prop"));
var _toPairs = _interopRequireDefault(require("lodash/fp/toPairs"));
var _formik = require("formik");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var isDirty = (0, _compose["default"])((0, _any["default"])(_identity["default"]), (0, _map["default"])(_last["default"]), _toPairs["default"], (0, _prop["default"])('touched'));
function useForm(formikConfig) {
  var formikBag = (0, _formik.useFormik)(formikConfig);
  return _objectSpread(_objectSpread({}, formikBag), {}, {
    dirty: isDirty(formikBag)
  });
}